import type { CompanySkill } from './types';

/** The draft's audience does not describe a published revision shown to a reader. */
export function skillSharingPresentation(skill: CompanySkill): CompanySkill {
  if (!skill.canShare && skill.publishedRevision === skill.draft?.revision) {
    return { ...skill, visibility: 'company' };
  }
  return skill;
}
